module.exports = __webpack_public_path__ + "img/ulubv_logo.e08ee348.png";